import {CalculatorResolver as resolver} from "app/components/calculator/calculator.resolver";
import {CalculatorSelector as selector} from "app/components/calculator/calculator.selector";
import {CalculatorInitializer as initializer} from "app/components/calculator/calculator.init";
import {sortCountriesBySuggested} from "app/components/calculator/helpers/sorter";
import {mapValues} from 'lodash';

import {
    LOAD_DIRECTIONS,
    LOAD_CURRENCIES,
    LOAD_DELIVERY_METHODS,
    LOAD_DELIVERY_METHODS_PROGRESS,
    GET_EXCHANGE_RATE,
    SET_AVAILABLE_COUNTRIES_IN,
    SET_AVAILABLE_COUNTRIES_OUT,
    SET_AVAILABLE_CURRENCIES_IN,
    SET_AVAILABLE_CURRENCIES_OUT,
    SET_COUNTRY_IN,
    SET_COUNTRY_OUT,
    SET_AMOUNT_IN,
    SET_AMOUNT_OUT,
    SET_FEE,
    SET_DELIVERY_METHOD,
} from "reducers/calculator";

export const CalculatorActions = () => {
    const loadAvailableDirectionsAction = () => {
        return async (dispatch, getState) => {
            const directionsPreLoaded = selector.getDirections(getState).directions;
            const directions = directionsPreLoaded ? directionsPreLoaded : await resolver.getAvailableDirections();

            dispatch({
                type: LOAD_DIRECTIONS,
                payload: mapValues(directions, sortCountriesBySuggested)
            });

            const {
                availableCountriesIn,
                countryIn,
                availableCountriesOut,
                countryOut,
            } = selector.getCountries(getState);

            dispatch(setAvailableCountriesInAction(availableCountriesIn));
            dispatch(setAvailableCountriesOutAction(availableCountriesOut));
            dispatch(setCountryInAction(countryIn));
            dispatch(setCountryOutAction(countryOut));
        }
    };

    const loadAvailableCurrenciesAction = () => {
        return async (dispatch, getState) => {
            const {countryIn, countryOut} = getState().calculator;
            const currencies = await resolver.getAvailableCurrencies(countryIn, countryOut);

            dispatch({
                type: LOAD_CURRENCIES,
                payload: currencies
            });

            const {
                availableCurrenciesIn,
                amountIn,
                availableCurrenciesOut,
                amountOut,
            } = selector.getCurrencies(getState);

            dispatch(setAvailableCurrenciesInAction(availableCurrenciesIn));
            dispatch(setAvailableCurrenciesOutAction(availableCurrenciesOut));
            dispatch(setAmountInAction(amountIn));
            dispatch(setAmountOutAction(amountOut));
        }
    };

    const loadAvailableDeliveryMethodsAction = () => {
        return async (dispatch, getState) => {
            dispatch({
                type: LOAD_DELIVERY_METHODS_PROGRESS,
                payload: true
            });

            const state = getState().calculator;
            const availableDeliveryMethods = await resolver.getAvailableDeliveryMethods({
                countryIn: state.countryIn,
                currencyIn: state.amountIn.getCurrency,
                countryOut: state.countryOut,
                currencyOut: state.amountOut.getCurrency,
                amount: state.amountIn.getAmount,
            });

            dispatch({
                type: LOAD_DELIVERY_METHODS,
                payload: availableDeliveryMethods
            });

            const {method, fee} = selector.getDelivery(getState);
            dispatch(setDeliveryMethodAction(method));
            dispatch(setFeeAction(fee));

            dispatch({
                type: LOAD_DELIVERY_METHODS_PROGRESS,
                payload: false
            });
        }
    };

    const getExchangeRateAction = () => {
        return async(dispatch, getState) => {
            const {amountIn, amountOut} = getState().calculator;
            const rate = await resolver.getExchangeRate(
                amountIn.getCurrency,
                amountOut.getCurrency,
                amountIn.getAmount
            );

            dispatch({
                type: GET_EXCHANGE_RATE,
                payload: rate
            })
        }
    };

    const setAvailableCountriesInAction = (countryIn) => {
        return {
            type: SET_AVAILABLE_COUNTRIES_IN,
            payload: countryIn,
        }
    };

    const setAvailableCountriesOutAction = (countryIn) => {
        return {
            type: SET_AVAILABLE_COUNTRIES_OUT,
            payload: countryIn,
        }
    };

    const setAvailableCurrenciesInAction = (countryIn) => {
        return {
            type: SET_AVAILABLE_CURRENCIES_IN,
            payload: countryIn,
        }
    };

    const setAvailableCurrenciesOutAction = (countryIn) => {
        return {
            type: SET_AVAILABLE_CURRENCIES_OUT,
            payload: countryIn,
        }
    };

    const setCountryInAction = (countryIn) => {
        return {
            type: SET_COUNTRY_IN,
            payload: countryIn,
        }
    };

    const setCountryOutAction = (countryOut) => {
        return {
            type: SET_COUNTRY_OUT,
            payload: countryOut,
        }
    };

    const setAmountInAction = (amountOut) => {
        return {
            type: SET_AMOUNT_IN,
            payload: amountOut,
        }
    };

    const setAmountOutAction = (amountOut) => {
        return {
            type: SET_AMOUNT_OUT,
            payload: amountOut,
        }
    };

    const setFeeAction = (fee) => {
        return {
            type: SET_FEE,
            payload: fee,
        };
    };

    const setDeliveryMethodAction = (method) => {
        return {
            type: SET_DELIVERY_METHOD,
            payload: method,
        }
    };

    return {
        initCalculatorAction: () => initializer,
        loadAvailableDirectionsAction,
        loadAvailableCurrenciesAction,
        loadAvailableDeliveryMethodsAction,
        setAvailableCountriesInAction,
        setAvailableCountriesOutAction,
        setAvailableCurrenciesInAction,
        setAvailableCurrenciesOutAction,
        setCountryInAction,
        setCountryOutAction,
        setAmountInAction,
        setAmountOutAction,
        setFeeAction,
        setDeliveryMethodAction,
        getExchangeRateAction,
    }
};
